import { useCallback } from 'react';
import { getReportChartType } from 'reporting-data/report/reportGetters';
import { transformReportChartType } from 'reporting-data/report/report-transformations/chartTypeTransformations';
import ChartTypeSelectableBoxes from '../components/ChartTypeSelectableBoxes';
import ChartTypeSelect from '../components/ChartTypeSelect';
import useFetchUserInfo from '../../../hooks/useFetchUserInfo';
import { getChartTypeOptions, trackChartTypeChange } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
const ConfigReportChartTypeToggleDropdown = ({
  onChange,
  report,
  excludedChartTypes,
  trackingApplicationName,
  trackingAssetType,
  trackingScreenName,
  useSelectableBoxesLayout,
  ['data-test-id']: dataTestId = 'chart-type-toggle'
}) => {
  var _userInfo$user;
  const userInfo = useFetchUserInfo();
  const scopes = (userInfo === null || userInfo === void 0 || (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user.scopes) || [];
  const chartTypeOptions = getChartTypeOptions(report, scopes, excludedChartTypes);
  const onChartTypeChange = useCallback(({
    target: {
      value
    }
  }) => {
    const result = transformReportChartType(report, value);
    trackChartTypeChange(value, trackingAssetType, trackingApplicationName, trackingScreenName);
    if (result) {
      onChange(result);
    }
  }, [report, onChange, trackingAssetType, trackingApplicationName, trackingScreenName]);
  if (chartTypeOptions.length < 2) {
    return null;
  }
  if (useSelectableBoxesLayout) {
    return /*#__PURE__*/_jsx(ChartTypeSelectableBoxes, {
      "data-test-id": dataTestId,
      value: getReportChartType(report),
      options: chartTypeOptions,
      onChartTypeChange: onChartTypeChange
    });
  }
  return /*#__PURE__*/_jsx(ChartTypeSelect, {
    "data-test-id": dataTestId,
    value: getReportChartType(report),
    options: chartTypeOptions,
    onChange: onChartTypeChange
  });
};
export default ConfigReportChartTypeToggleDropdown;